import { ReactNode } from 'react'
import localFont from 'next/font/local'

import { BaseFontProvider } from './base-font-provider'

// Self-hosted (latin subset) instead of next/font/google so a cold `next build`
// has no build-time dependency on Google Fonts. Plus Jakarta Sans is a variable
// font: one woff2 covers the whole weight range. Re-vendor via
// scripts/vendor-google-fonts.mjs.
const plusJakartaSans = localFont({
  src: '../../public/fonts/plus-jakarta-sans/PlusJakartaSans-variable.woff2',
  weight: '200 800',
  display: 'swap',
  // A generic family last, so text degrades to sans-serif, never Times,
  // when the face cannot load (a session replay player included).
  fallback: ['system-ui', 'sans-serif'],
})

export const PlusJakartaSansProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  return <BaseFontProvider font={plusJakartaSans}>{children}</BaseFontProvider>
}
